import { Users, Briefcase, Clock, DollarSign, BarChart3 } from "lucide-react";
import { Card, CardContent } from "../../components/ui/card";

const fmtCurr = (v) => v == null ? "—" : "$" + v.toLocaleString();
const fmtHrs = (h) => h == null ? "—" : h.toLocaleString() + "h";

function KPICard({ title, value, sub, icon: Icon }) {
  return (
    <Card className="bg-card/50 backdrop-blur">
      <CardContent className="p-4">
        <div className="flex items-start justify-between">
          <div>
            <p className="text-xs text-muted-foreground uppercase tracking-wider">{title}</p>
            <p className="text-2xl font-light mt-1" style={{ fontFamily: 'var(--font-sans)' }}>{value}</p>
            {sub && <p className="text-xs text-muted-foreground mt-0.5">{sub}</p>}
          </div>
          {Icon && <Icon className="w-5 h-5 text-muted-foreground/60" />}
        </div>
      </CardContent>
    </Card>
  );
}

export default function PerformanceKPIs({ loading, overview, mtd, canCost }) {
  if (loading) {
    return (
      <div className="grid grid-cols-2 md:grid-cols-5 gap-4">
        {[1, 2, 3, 4, 5].map(i => <Card key={i} className="animate-pulse"><CardContent className="p-4 h-20" /></Card>)}
      </div>
    );
  }
  
  if (!overview) return null;

  return (
    <div className="grid grid-cols-2 md:grid-cols-5 gap-4">
      <KPICard title="Allocated Hours" value={fmtHrs(overview.total_allocated_hours)} sub={mtd ? "MTD" : "Full"} icon={Clock} />
      {canCost && <KPICard title="Allocated Cost" value={fmtCurr(overview.total_allocated_cost)} sub={mtd ? "MTD" : "Full"} icon={DollarSign} />}
      <KPICard title="Active Artists" value={overview.active_artists_count} sub="Allocated" icon={Users} />
      <KPICard title="Programs" value={overview.active_programs_count} sub="Touched" icon={Briefcase} />
      <KPICard title="Rate Coverage" value={overview.allocation_coverage_percent + "%"} sub="With rates" icon={BarChart3} />
    </div>
  );
}
